import React from "react";
import PropTypes from "prop-types";
import { Grid, Paper, Typography } from "@material-ui/core";
import { formatAmount, parseDateMDY, toCamelCase } from "utils/Utils";

const styles = {
  card: {
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 24,
    marginBottom: 24,
    boxShadow: "none",
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    color: "#1E3A5F",
    marginBottom: 24,
  },
  item: {
    marginBottom: 24,
  },
  label: {
    fontSize: 13,
    color: "#6B7280",
    marginBottom: 6,
    fontWeight: 500,
  },
  value: {
    fontSize: 15,
    fontWeight: 600,
    color: "#1F2937",
    wordBreak: "break-word",
  },
};

const Field = ({ label, value }) => (
  <Grid item xs={12} sm={6} md={3}>
    <div style={styles.item}>
      <Typography style={styles.label}>{label}</Typography>
      <Typography style={styles.value}>
        {value || "NA"}
      </Typography>
    </div>
  </Grid>
);

const IncomeDetailsReview = ({
  incomeDetails,
  userLeadIdDetails,
  adhaarDetails,
}) => {
  return (
    <Paper style={styles.card}>
      <Typography style={styles.title}>
        Income Details
      </Typography>

      <Grid container spacing={2}>
        <Field
          label="Employment Type"
          value={toCamelCase(incomeDetails?.employmentType)}
        />

        <Field
          label="Monthly Income"
          value={formatAmount(incomeDetails?.monthlyIncome)}
        />

        <Field
          label="PAN Number"
          value={incomeDetails?.panNumber}
        />

        <Field
          label="Aadhaar Number"
          value={adhaarDetails?.adhaarNumber?.replace(/\d(?=\d{4})/g, "*")}
        />

        <Field
          label="PF/UAN"
          value={incomeDetails?.pfUan}
        />

        <Field
          label="Date of Birth"
          value={parseDateMDY(incomeDetails?.dob)}
        />

        <Field
          label="Mobile Number"
          value={userLeadIdDetails?.mobile_number}
        />
      </Grid>
    </Paper>
  );
};

Field.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
};

IncomeDetailsReview.propTypes = {
  incomeDetails: PropTypes.object,
  userLeadIdDetails: PropTypes.object,
  adhaarDetails: PropTypes.object,
};

export default IncomeDetailsReview;